export const isDEV = window.location.host.indexOf("localhost") !== -1;
export const HOST = isDEV ? "http://localhost:3050/" : "https://api.onradar.io/";
export const DISABLED_EXPAND_SIDEBAR_ROUTES = ["/flows/node-editor"];
export const CRISP_KEY = "48475c46-4cc3-40b9-8b44-f70d45132baf";